import { BaseRouteService } from 'core/services';

class SyncRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'sync/';
	}

	syncByChannelAsync(id, sourceOfChange) {
		return super.get(this.base + 'sync-by-channel/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	syncAsync(sourceOfChange) {
		return super.get(this.base + 'sync/?sourceOfChange={sourceOfChange}', null, { sourceOfChange });
	}

	acknowledgeWalmartOrder(id, sourceOfChange) {
		return super.get(this.base + 'acknowledge-walmart-order/{id}/?sourceOfChange={sourceOfChange}', id, {
			sourceOfChange,
		});
	}
}

export default SyncRouteService;
